/* eslint-disable no-unreachable */
// import Vue from 'vue';

// 图文直播聊天组件

import ContextMenu from '@/components/common/context-menu';
import MultiImgSelect from '../multiImgSelect/index.vue';

import { decodeText } from '@/utils/decodeText';
// import i18n from '@/locales/i18n';
import { mapState } from 'vuex';
import { emojiMap, emojiName, emojiUrl } from '@/utils/emojiMap';
import { LIVE_STAGE } from '@/constants/room';
import { tuwenRoomSendMsg, tuwenRoomSetTopMsg, tuwenRoomGetMsgList, tuwenRoomGetMsgListSum, tuwenRoomDelMsg } from '@/api/live';
import { isAdminstator } from '../../../diff.js'

export default {
  data() {
    return {
      chatRoomEnable: true,

      inputMsg: '',
      popoverVisible: false,
      isNotExistRoom: false,
      emojiMap,
      emojiName,
      emojiUrl,

      isAdminstator,
      loading: false,

      messageList: [], // 消息列表
      muteUserIdList: [], // 被禁言的用户ID列表

      isSendMsgFlag: false, // 发送消息判断
      msgLoopTimer: null,  // 轮询定时器
      msgLoopTime: 10 * 1000,  // 间隔时间

      pagination: {
        page: 0,
        size: 10,  // 暂时改为2
        defaultSize: 10, // 暂时改为2
        total: 0
      },

      imgFileList: [],

      currentNode: null,  // 记录右键点击，当前消息
      currentIndex: -1,   // 记录右键点击，当前消息Index

      isEditIng: false, // true 为正在编辑消息
      editNode: null,  // 右键点击编辑，当前消息拷贝体
      editIndex: -1,  // 右键点击编辑，当前消息Index
      editTime: null,  // 右键点击编辑，当前消息的时间
      sendEditScrollEndIndex: -1, // 编辑消息滚动后，标识动画

      isViewMsgIng: false, // 正在查看消息
      isAscOrder: false,  // true 为正序
    };
  },
  components: {
    ContextMenu,
    MultiImgSelect
  },
  computed: {
    ...mapState({
      liveStage: state => state.player.liveStage,
      userInfo: state => state.player.userInfo,
      roomId: state => state.player.roomId,
      anchorUserId: state => state.player.anchorUserId,
      sendMsgEnable: state => state.player.sendMsgEnable,
      isActive: state => state.player.isActive,

      // '-99': { value: -99, label: '已禁用', color: '#aaa' }
      // 0: { value: 0, label: '未开播', color: '#70b603' },
      // 1: { value: 1, label: '直播中', color: '#108de9' },
      // 2: { value: 2, label: '已结束', color: '#aaa' },
      // 3: { value: 3, label: '预告', color: '#f59a23' },

      // 已结束，用升序
      // isAscOrder: state => state.player.isActive == 2
      // isAscOrder: state => state.player.isActive != 2

      // chatRoomEnable: state => state.player.chatRoomEnable,
    }),
    groupID() {
      return this.roomId.toString();
    },
    userData() {
      return {
        userId: this.userInfo.userId,
      };
    },
    isLiveEnded() {
      return this.liveStage === LIVE_STAGE.ENDED;
    },
    // 客户未登录时展示登录提示
    showLoginAttention() {
      return !this.userInfo;
    },
    inputPlaceHolder() {
      if (this.showLoginAttention) {
        return '';
      }
      if (!this.sendMsgEnable) {
        return '禁言中';
      }
      return '说点什么';
    },
  },
  watch: {

    userData: {
      immediate: true,
      async handler(val) {
        if (this.roomId && this.chatRoomEnable) {
          // 已结束，用升序
          // 只在初始化赋值一次，不考虑直播状态突然切换的问题
          this.isAscOrder = this.isActive == 2

          // 测试倒序
          // this.isAscOrder = this.isActive != 2

          // console.log('初始化加载完成,开始轮询', this.isActive)

          this.initMsgList((hasMoreFlag) => {
            console.log('初始化加载完成,开始轮询')

            // 暂时注释
            // ps 默认首次先加载全部，然后从最后一项，再开始加载分页数据

            // 将轮询页码调整至最后一页, 页码从 0 开始
            const curpage = Math.ceil(this.pagination.total / this.pagination.size) - 1;

            this.pagination.page = curpage;

            console.log('当前页', curpage)

            this.getMsgList();
          });
        }
      },
    },
    // 发出一条新消息，自动到最底部 / 顶部
    messageList(newVal, oldVal) {
      // this.$nextTick(() => {
      //   const msg =  this.$refs.box;
      //   msg.scrollTop = msg.scrollHeight;
      // });

      // debugger
      console.log('messageList', oldVal)

      if (this.isViewMsgIng) {
        return false;
      }

      // 编辑信息，手动处理滚动事项
      if (this.isEditIng) {
        return false;
      }

      setTimeout(() => {
        const msg =  this.$refs.box;
        let _top = 0;

        if (this.isAscOrder) { // 正序，滚动至底
          _top = msg.scrollHeight;
        } else {  // 倒序，滚动至顶
          // oldVal 没数据，默认是第一次请求列表
          if (!oldVal || (Array.isArray(oldVal) && oldVal.length === 0)) {
            _top = 0;
          } else {
            // 这里需扣掉置顶的部分, 查找置顶位置下一个位置，即首个 stickyTop 为零的值
            const idx = this.getSticky0Index(newVal);
            if (idx > -1) {
              const $myTuWenTimeLine = document.getElementsByClassName('myTuWenTimeLine')
              if ($myTuWenTimeLine.length > 0) {
                const $msgList = $myTuWenTimeLine[0].getElementsByClassName('el-timeline-item')
                if ($msgList.length > 0) {
                  _top = $msgList[idx].offsetTop
                }
              }
            }
          }
        }

        // 滚动至相应位置
        msg.scrollTop = _top;
      }, 200)
    },
  },
  methods: {
    // 获取用户昵称
    getUserNick({ nick, userID }) {
      return nick ? nick : userID;
    },
    // 是否是主播的消息
    isAnchorMessage({ userID }) {
      return userID === this.anchorUserId;
    },
    // 获取消息时间
    getMessageTime({ time }) {
      // let hour = new Date(time * 1000).getHours();
      // let minute = new Date(time * 1000).getMinutes();
      // hour = hour >= 10 ? hour.toString() : `0${hour}`;
      // minute = minute >= 10 ? minute.toString() : `0${minute}`;
      // return `${hour}:${minute}`;

      const timestamp = time;
      if (!timestamp) return ''
      const publishTime = new Date(timestamp) / 1000
      const date = new Date(publishTime * 1000)
      const Y = date.getFullYear()
      let M = date.getMonth() + 1
      let D = date.getDate()
      let H = date.getHours()
      let m = date.getMinutes()
      let s = date.getSeconds()
      // 小于10的在前面补0
      if (M < 10) {
        M = `0${M}`
      }
      if (D < 10) {
        D = `0${D}`
      }
      if (H < 10) {
        H = `0${H}`
      }
      if (m < 10) {
        m = `0${m}`
      }
      if (s < 10) {
        s = `0${s}`
      }
      return `${Y}-${M}-${D} ${H}:${m}:${s}`
      // return `${M}-${D} ${H}:${m}:${s}`
    },
    // 发送消息，包含文字、图片
    handleSendMsg() {
      if (!this.sendMsgEnable) {
        this.$message.warning('禁言中');
        return false;
      }

      if (!this.chatRoomEnable) {
        this.$message.warning('聊天室暂时关闭');
        return false;
      }

      const imgArr = [];
      if (this.$refs.mutiImgSelect && this.$refs.mutiImgSelect.imgList && this.$refs.mutiImgSelect.imgList.length > 0) {
        this.$refs.mutiImgSelect.imgList.map((item) => {
          imgArr.push({
            // width: item.width,
            // height: item.height,
            thumburl: item.thumburl,
            url: item.url,
          })
        })
      }

      if ((this.showLoginAttention || this.inputMsg === '' || /^\s+$/gi.test(this.inputMsg)) && imgArr.length === 0) {
        this.$message.warning('发送内容不能为空~');
        return false;
      }


      // console.log('点击发送', this.$refs.mutiImgSelect.imgList, this.inputMsg)
      // return false

      this.sendMessage(this.inputMsg, imgArr, () => {
        this.inputMsg = '';
        this.$refs.mutiImgSelect.reset();
        this.popoverVisible = false;
      });
    },
    // 选择表情
    chooseEmoji(item) {
      if (this.showLoginAttention) {
        return;
      }
      this.inputMsg += item;
      !this.$isMobile && this.$refs.input.focus();
    },
    // 处理登录
    handleLogin() {
      this.$eventBus.$emit('showLoginCard');
    },

    // ----------- 收发消息相关 ----------

    // 发送消息
    async sendMessage(msgText, imgArr = [], callback) {
      if (this.isSendMsgFlag) {
        this.$message.error('正在发送消息，请稍等~');
        return false;
      }

      this.isSendMsgFlag = true;
      // 创建消息并发送到对应群组
      const messageItem = {
        nick: this.userInfo.userName || '',
        content: msgText,
        renderContent: decodeText(msgText),
        userID: this.userInfo.userId,
        // eslint-disable-next-line newline-per-chained-call
        time: Number(Date.now()),
        imageUrl: imgArr,
        stickyTop: 0
      };

      console.log(messageItem, '???');
      try {
        const msgRes = await tuwenRoomSendMsg({
          targetType: 'liveStream',
          // targetId: '', // 稿件ID
          liveStreamId: this.roomId,
          content: msgText,
          nickname: this.userInfo.userName,
          imageUrl: imgArr,
          isAdmin: isAdminstator ? 1 : 0,
        });

        messageItem.id = msgRes.id;

        if (msgRes.hasSensword) {
          messageItem.state = 'fail';
          messageItem.hasSensword = true;
          messageItem.time = Number(msgRes.liveStreamTimestamp || new Date(msgRes.modDate).getTime());
          this.$message.warning('不可以发送敏感信息~');
        } else {
          messageItem.state = 'success';
        }
      } catch (error) {
        messageItem.state = 'fail';
      }
      if (this.isAscOrder) {  // 正序
        this.messageList.push(messageItem);
      } else {    // 倒序
        // 这里处理置顶信息
        // 这里需查找首个 stickyTop 为零的地方
        const idx = this.getSticky0Index(this.messageList);
        if (idx > -1) {
          this.messageList.splice(idx, 0, messageItem);
        } else {
          this.messageList.unshift(messageItem);
        }
      }
      this.isSendMsgFlag = false;

      if (typeof(callback) === 'function') {
        callback()
      }
    },

    // 重发信息
    reSendMessage(item) {
      if (item.hasSensword) {
        this.$message.warning('不可以发送敏感信息~');
        return false;
      }
      console.log(item);
      if (item.imageUrl && item.imageUrl.length > 0) {
        this.sendImage(item.imageUrl)
      } else {
        this.sendMessage(item.content)
      }
    },

    // 轮询请求消息列表
    async getMsgList() {
      this.stopGetMsgList();

      this.msgLoopTimer = window.setInterval(async () => {
        const listSum  = await tuwenRoomGetMsgListSum({ roomId: this.roomId });

        this.pagination.total = listSum;

        if (this.pagination.total ===  this.messageList.length) {
          console.log('总数没变')
          return false;
        }

        const params = Object.assign({
          roomId: this.roomId,
          sort: this.isAscOrder ? 'ASC' : 'DESC'
        }, this.pagination);

        tuwenRoomGetMsgList(params).then((res) => {
          if (res.length > 0) {
            this.handleMsgList(res, (hasMoreFlag) => {
              if (hasMoreFlag) {
                this.pagination.page = this.pagination.page + 1;

                console.log('加分页', this.pagination.page)
              }
            })
          }
        });
      }, this.msgLoopTime)
    },

    // 停止轮询请求列表数据
    stopGetMsgList() {
      if (this.msgLoopTimer) window.clearInterval(this.msgLoopTimer);
    },

    // 初始化加载聊天记录 列表
    async initMsgList(callback) {
      const listSum  = await tuwenRoomGetMsgListSum({ roomId: this.roomId });

      this.pagination.total = listSum;

      // 判断总数一共有多少
      // this.pagination.size = Math.floor(listSum / 2);

      const params = Object.assign({
        roomId: this.roomId,
        sort: this.isAscOrder ? 'ASC' : 'DESC'
      }, this.pagination);

      // 暂时注释
      if (listSum) {
        params.size = listSum;
      }

      this.messageList = [];
      tuwenRoomGetMsgList(params).then((res) => {
        if (res.length > 0) {
          this.handleMsgList(res, (hasMoreFlag) => {
            callback(hasMoreFlag)
          })
        }
      });
    },

    // 处理直播列表
    handleMsgList(res, callback) {
      console.log('直播列表', res, this.messageList);

      // 处理新数据, 过滤重复数据
      const newIdList = res.filter(item => !this.messageList.some(x => x.id === item.id));
      console.log('diff', newIdList);

      // 存储处理后的数组
      const arr = [];

      newIdList.map((item, index) => (

        // console.log(decodeText(item.content))

        // modDate: '2023-05-24T09:05:57.793+0000',
        // id: '646dd375bb070177df4cadc0',
        // targetType: 'liveStream',
        // liveStreamId: '1680147205672',
        // content: '图文\n',
        // nickname: 'XK7279952',
        // imageUrl: [],
        // title: '图文\n'
        // stickyTop: 0

        arr.push({
          id: item.id,
          content: item.content,
          renderContent: decodeText(item.content),
          // userID: item.publisherFullname,
          // hasSensword: item.hasSensword ? item.hasSensword : false,
          nick: item.nickname || '', // 显示中文名
          // eslint-disable-next-line newline-per-chained-call
          time: Number(item.liveStreamTimestamp || new Date(item.modDate).getTime()),
          imageUrl: item.imageUrl || [],
          stickyTop: item.stickyTop || 0
        })

      ));

      // 这里处理置顶信息

      if (this.isAscOrder) { // 正序
        // arr.sort((a, b) => a.time - b.time);
        this.messageList = this.messageList.concat(arr);
      } else {  // 倒序
        // arr.sort((a, b) => b.time - a.time);
        // this.messageList = arr.concat(this.messageList);

        // 倒序，整个放进去重新排序
        this.messageList = this.getSortAfterMsgList(arr.concat(this.messageList));
      }

      // console.log(this.messageList)

      // hasMore
      if (typeof callback === 'function') {
        if (this.messageList.length < this.pagination.total) {
          callback(true)
        } else {
          callback(false)
        }
      }
    },

    // 发送图片消息
    async sendImage(imgList, callback) {
      if (this.isSendMsgFlag) {
        this.$message.error('正在发送消息，请稍等~');
        return false;
      }

      this.isSendMsgFlag = true;
      // 创建消息并发送到对应群组
      const messageItem = {
        nick: this.userInfo.userName || '',
        content: '',
        renderContent: '',
        userID: this.userInfo.userId,
        // eslint-disable-next-line newline-per-chained-call
        time: Number(Date.now()),
        imageUrl: imgList,
        stickyTop: 0
        // time: Number(Date.now().toString().substr(0, 10)),
      };

      console.log(messageItem, '???');
      try {
        const msgRes = await tuwenRoomSendMsg({
          targetType: 'liveStream',
          // targetId: '', // 稿件ID
          liveStreamId: this.roomId,
          content: '',
          nickname: this.userInfo.userName,
          imageUrl: imgList,
          isAdmin: isAdminstator ? 1 : 0,
        });

        messageItem.id = msgRes.id;

        if (msgRes.hasSensword) {
          messageItem.state = 'fail';
          messageItem.hasSensword = true;
          messageItem.time = Number(msgRes.liveStreamTimestamp || new Date(msgRes.modDate).getTime());
          this.$message.warning('不可以发送敏感信息~');
        } else {
          messageItem.state = 'success';
        }
      } catch (error) {
        messageItem.state = 'fail';
      }

      if (this.isAscOrder) {  // 正序
        this.messageList.push(messageItem);
      } else {
        // 倒序处理置顶消息
        // 这里需查找首个 stickyTop 为零的地方
        const idx = this.getSticky0Index(this.messageList);
        if (idx > -1) {
          this.messageList.splice(idx, 0, messageItem);
        } else {
          this.messageList.unshift(messageItem);
        }
      }

      this.isSendMsgFlag = false;

      if (typeof(callback) === 'function') {
        callback()
      }
    },

    // 点击直接发送图片，只发图片
    onlySendImgs() {
      const imgArr = [];

      if (this.$refs.mutiImgSelect && this.$refs.mutiImgSelect.imgList && this.$refs.mutiImgSelect.imgList.length > 0) {
        this.$refs.mutiImgSelect.imgList.map((item) => {
          imgArr.push({
            // width: item.width,
            // height: item.height,
            thumburl: item.thumburl,
            url: item.url,
          })
        })
      }

      if (imgArr.length === 0) {
        this.$message.warning('发送图片不能为空~');
        return false;
      }

      this.sendImage(imgArr, () => {
        this.$refs.mutiImgSelect.reset();
      });
    },


    // 右键点击开始
    contextmenu(node, index) {
      if (!isAdminstator) {
        return false
      }
      event.preventDefault();
      this.currentNode = node;
      this.currentIndex = index;
      this.$refs.allMenu.open(event);
    },

    // 右键点击取消
    ctxCancel() {
      if (this.isEditIng) {
        return false
      }
      console.log('右键点击取消')
      this.cleanEditItem();
    },

    // 隐藏
    /*     hideMsg(currentNode) {
      console.log(currentNode);

      alert('正在开发中');
      return false

      this.$alert(
        '隐藏该条消息？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          currentNode.state = 'hide'
        })
        .catch(() => {

        })
    }, */


    deleteMsg(currentNode) {
      console.log(currentNode)

      this.$alert(
        '删除该条信息？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          // alert('正在开发中')
          currentNode.state = 'delete'
          tuwenRoomDelMsg({ roomId: this.roomId, id: currentNode.id }).then(() => {
            this.$message.success('操作成功~');
            const idx = this.messageList.findIndex(item => item.id === currentNode.id);
            if (idx > -1) {
              this.isViewMsgIng = true;

              this.messageList.splice(idx, 1);
            }
          })
        })
        .catch(() => {

        })
    },

    // 2、进入元素
    mouseenter() {
      // console.log('mouseenter')
      this.isViewMsgIng = true;
    },
    // 3、移动
    mousemove() {
      // console.log('mousemove')
      this.isViewMsgIng = true;
    },
    // 5、离开元素
    mouseleave() {
      // console.log('mouseleave')
      this.isViewMsgIng = false;
    },

    // 清除右键选中的消息及其下标
    cleanEditItem() {
      this.editNode = null;
      this.editIndex = -1;
    },

    // 编辑消息
    editMsg(_currentNode, _index) {
      // console.log(_currentNode, _index)

      // 停止轮询
      this.stopGetMsgList();
      // 停止列表自动滚动
      this.isEditIng = true;

      this.editNode = Object.assign({}, _currentNode);
      this.editIndex = _index;

      console.log(JSON.stringify(this.editNode), this.editIndex)

      // 回显文字
      this.inputMsg = this.editNode.content || '';
      // 回显图片
      this.$refs.mutiImgSelect.reset();
      this.$refs.mutiImgSelect.setImgList(this.editNode.imageUrl || []);
      // 回显时间

      this.editTime = this.editNode.time ? new Date(this.editNode.time) : new Date();
      console.log('点击编辑消息', this.$refs.mutiImgSelect.imgList, this.inputMsg)
    },

    // 确认修改
    confirmEdit() {
      // if (!this.sendMsgEnable) {
      //   this.$message.warning('禁言中');
      //   return false;
      // }

      // if (!this.chatRoomEnable) {
      //   this.$message.warning('聊天室暂时关闭');
      //   return false;
      // }

      const imgArr = [];
      if (this.$refs.mutiImgSelect && this.$refs.mutiImgSelect.imgList && this.$refs.mutiImgSelect.imgList.length > 0) {
        this.$refs.mutiImgSelect.imgList.map((item) => {
          imgArr.push({
            // width: item.width,
            // height: item.height,
            thumburl: item.thumburl,
            url: item.url,
          })
        })
      }

      // if ((this.showLoginAttention || this.inputMsg === '' || /^\s+$/gi.test(this.inputMsg)) && imgArr.length === 0) {
      //   this.$message.warning('发送内容不能为空~');
      //   return false;
      // }

      console.log('点击修改', this.$refs.mutiImgSelect.imgList, this.inputMsg, this.editTime)

      this.sendEditMessage(this.inputMsg, imgArr, this.editTime);

      return false
    },

    // 发送编辑信息
    async sendEditMessage(msgText, imgArr = [], time) {
      if (this.isSendMsgFlag) {
        this.$message.error('正在修改消息，请稍等~');
        return false;
      }

      this.isSendMsgFlag = true;

      // 创建消息并发送到对应群组
      const messageItem = {
        id: this.editNode.id || '',
        nick: this.userInfo.userName || '',
        content: msgText,
        renderContent: decodeText(msgText),
        userID: this.userInfo.userId,
        // eslint-disable-next-line newline-per-chained-call
        time: time ? new Date(time).getTime() : Number(Date.now()),
        imageUrl: imgArr,
        stickyTop: 0
        // time: Number(Date.now().toString().substr(0, 10)),
      };

      console.log(messageItem, '???');

      try {
        // 修改接口
        const msgRes = await tuwenRoomSendMsg({
          targetType: 'liveStream',
          // targetId: '', // 稿件ID
          liveStreamId: this.roomId,
          content: msgText,
          nickname: this.userInfo.userName,
          imageUrl: imgArr,
          isAdmin: isAdminstator ? 1 : 0,
          id: messageItem.id,
          liveStreamTimestamp: messageItem.time,
          // stickyTop: 8888,
        });

        messageItem.id = msgRes.id;

        if (msgRes.hasSensword) {
          messageItem.state = 'fail';
          messageItem.hasSensword = true;
          // messageItem.time = Number(new Date(msgRes.modDate).getTime());
          this.$message.warning('不可以发送敏感信息~');
          return false
        }

        messageItem.state = 'success';
      } catch (error) {
        messageItem.state = 'fail';
      }

      this.isSendMsgFlag = false;

      // 请求失败，不继续往下走
      if (messageItem.state !== 'success') {
        this.$message.error('修改失败，请重试~');
        return false
      }

      // 修改数组中的某一项
      const tempArr = [...this.messageList];
      // 替换修改项
      tempArr[this.editIndex] = messageItem;

      this.messageList = this.getSortAfterMsgList(tempArr);

      // 赋值后处理
      this.$nextTick(() => {
        // 滚动至相应位置
        const idx = tempArr.findIndex(item => item.id === messageItem.id);
        if (idx > -1) {
          const $myTuWenTimeLine = document.getElementsByClassName('myTuWenTimeLine')
          if ($myTuWenTimeLine.length > 0) {
            const $msgList = $myTuWenTimeLine[0].getElementsByClassName('el-timeline-item')
            if ($msgList.length > 0) {
              const msgBoxRef =  this.$refs.box;
              msgBoxRef.scrollTop = $msgList[idx].offsetTop;
            }
          }

          // index
          this.sendEditScrollEndIndex = idx;
          setTimeout(() => {
            this.sendEditScrollEndIndex = -1;
          }, 5 * 1000);
        }

        this.cancelEdit();
      })
    },


    // 取消修改
    cancelEdit() {
      this.isEditIng = false;

      // 重置编辑模式下的信息
      this.inputMsg = '';
      this.$refs.mutiImgSelect.reset();
      this.editTime = null;
      this.cleanEditItem();

      // 重新开始请求列表数据
      this.getMsgList();
    },


    // 置顶消息
    async topMsg(_currentNode, _index, isToTopFlag) {
      // 编辑信息，手动处理滚动事项
      if (this.isEditIng) {
        this.$message.warning('请先完成修改操作后，再继续~');
        return false;
      }

      // 停止轮询
      this.stopGetMsgList();
      // 停止列表自动滚动
      this.isEditIng = true;

      let maxStickyTop = 0;

      // 置顶
      if (isToTopFlag) {
        this.messageList.map((item, inx) => {
          if (Number(item.stickyTop) > maxStickyTop) {
            maxStickyTop = Number(item.stickyTop)
          }
        });

        maxStickyTop += 1;
      }

      console.log(_currentNode, _index, maxStickyTop)

      try {
        // 修改接口
        this.loading = true;
        const msgRes = await tuwenRoomSetTopMsg({
          targetType: 'liveStream',
          // targetId: '', // 稿件ID
          liveStreamId: this.roomId,
          content: _currentNode.content,
          nickname: _currentNode.nick,
          imageUrl: _currentNode.imageUrl,
          isAdmin: isAdminstator ? 1 : 0,
          id: _currentNode.id,
          liveStreamTimestamp: _currentNode.time,
          stickyTop: maxStickyTop,
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }

      // 重新赋值 stickyTop
      this.messageList[_index].stickyTop = maxStickyTop;

      // 这里处理，置顶，取消置顶后的排序
      this.messageList = this.getSortAfterMsgList(this.messageList);

      this.$nextTick(() => {
        if (isToTopFlag) {
          // 滚动至顶部位置
          const inx = 0;
          const $myTuWenTimeLine = document.getElementsByClassName('myTuWenTimeLine')
          if ($myTuWenTimeLine.length > 0) {
            const $msgList = $myTuWenTimeLine[0].getElementsByClassName('el-timeline-item')
            if ($msgList.length > 0) {
              const msgBoxRef =  this.$refs.box;
              msgBoxRef.scrollTop = $msgList[inx].offsetTop;
            }
          }

          this.sendEditScrollEndIndex = inx;
          setTimeout(() => {
            this.sendEditScrollEndIndex = -1;
          }, 5 * 1000);
        }

        this.isEditIng = false;
        this.getMsgList();
      })
    },

    // 获取排序后的数据
    getSortAfterMsgList(arr) {
      const topArr = [];
      const msgArr = [];
      arr.map((item) => {
        if (item.stickyTop === 0) {
          msgArr.push(item)
        } else {
          topArr.push(item)
        }
      })
      // 重新按时间排序
      topArr.sort((a, b) => b.stickyTop - a.stickyTop);

      // 正常消息，用时间排序
      if (this.isAscOrder) { // 正序
        msgArr.sort((a, b) => a.time - b.time);
      } else {  // 倒序
        msgArr.sort((a, b) => b.time - a.time);
      }
      return topArr.concat(msgArr)
    },

    // 查找首个stickyTop为零的下标
    getSticky0Index(arr) {
      let idx = -1;
      if (Array.isArray(arr) && arr.length > 0) {
        for (let index = 0; index < arr.length; index++) {
          if (arr[index].stickyTop === 0) {
            idx = index;
            break;
          }
        }
      }
      return idx
    }
  },
  created() {
  },

  beforeDestroy() {
    this.stopGetMsgList();
  },
};
